import { render } from "./EditAssistanceNoteScheduled.vue?vue&type=template&id=2b97e62c&scoped=true"
import script from "./EditAssistanceNoteScheduled.vue?vue&type=script&lang=js"
export * from "./EditAssistanceNoteScheduled.vue?vue&type=script&lang=js"

import "./EditAssistanceNoteScheduled.vue?vue&type=style&index=0&id=2b97e62c&lang=css"
import "./EditAssistanceNoteScheduled.vue?vue&type=style&index=1&id=2b97e62c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b97e62c"]])

export default __exports__